import { OrderPicklistExtra, PageProps } from '../../components/types'
import HeaderDetail from '../../components/HeaderDetail'
import { PicklistItemCheckMvColumn } from '../../constants/Column'
import Modal from '../../components/Modal'
import Badge from '../../components/Badge'

import OrderPicklistReducer, { 
  INITIAL_STATE, 
  PicklistAction
} from '../../states/PicklistReducer'
import {
  pdCheckPicklistExtra,
  checkItemMovement,
  uncheckItemMovement,
  getExtraPicklist,
  getMovementsById
} from '../../states/PicklistAction'

import DataGrid, { RowsChangeData } from 'react-data-grid'

import { 
  useReducer, 
  useEffect,
  useState,
  useMemo
} from 'react'
import { AiOutlineCheckCircle } from 'react-icons/ai'

import { groupBy as rowGrouper } from 'lodash';

import { formatDateFromUnix } from '../../utilities/Format'

import { 
  DgtPdOrderPicklist, 
  DgtPdOrderPicklistMovement 
} from '../../models'

import { Link } from 'react-router-dom'

const PicklistCheckDetailExtra = ({ title, id, username, extraId, readOnly } : PageProps) => {

  const [ state, dispatch ] = useReducer(
    OrderPicklistReducer, INITIAL_STATE);
  
  const [ originalExtra, setOriginalExtra ] = useState<OrderPicklistExtra>()
  
  const [expandedGroupIds, setExpandedGroupIds] = useState<ReadonlySet<unknown>>(
    () => new Set<unknown>([''])
  );

  useEffect(() => {
    const fetchExtra = async (id: string) => {
      const extraPicklist = await getExtraPicklist(id)
      if (extraPicklist) {
        const orderInfo : DgtPdOrderPicklist = JSON.parse(extraPicklist?.orderInfo)
        
        const extraItems = extraPicklist.extraReturnItems || []
        const toPicklistItems: any = extraItems.map(itm => ({
          pk: itm?.orderId!,
          sk: `ITEM#${itm?.materialCode}`,
          id: itm?.id,
          materialType: '',
          materialCode: itm?.materialCode,
          materialDescription: itm?.materialDescription,
          materialUnit: itm?.materialUnit,
          batchLotNo: itm?.batchLotNo,
          requestQty: itm?.qty
        }))

        dispatch({ type: PicklistAction.Inited, payload: { header: {
          ...orderInfo,
          requestedBy: extraPicklist?.approvedBy, 
          requestedDateTime: extraPicklist?.approvedDateTime,
          approvedBy: extraPicklist.withdrawedBy ? extraPicklist.withdrawedBy : undefined,
          approvedDateTime: extraPicklist.withdrawedDateTime ? extraPicklist.withdrawedDateTime : undefined,
          kiNo: extraPicklist?.kiNo ? extraPicklist.kiNo : undefined,
          commentText: `${extraPicklist?.remark || ''}`,
          extraReturnId: extraPicklist?.id,
          checkedBy: extraPicklist.checkedBy ? extraPicklist.checkedBy : undefined,
          checkedDateTime: extraPicklist.checkedDateTime ? extraPicklist.checkedDateTime : undefined,
        }, items: toPicklistItems, comments: []}})

        setOriginalExtra(extraPicklist)
      }
    }

    fetchExtra(extraId!)
  }, [ extraId ])

  const onApproved = async () => {
    const updated = await pdCheckPicklistExtra(originalExtra!, username!)
    const head : DgtPdOrderPicklist = {
      ...header!,
      checkedBy: updated.checkedBy,
      checkedDateTime: updated.checkedDateTime
    }
    dispatch({ type: PicklistAction.PicklistUpdated, payload: { header: head } })
  }

  const openDialog = () => {
    dispatch({ type: PicklistAction.OpenDialog })
  }

  const closeDialog = () => {
    dispatch({ type: PicklistAction.CloseDialog })
  }

  const { header, showConfirmDialog, itemMovements, items } = state

  useEffect(() => {
    const fetchMovements = async (orderId: string) => {
      const mvs = (await getMovementsById(orderId)).filter(
        mv => mv.movementType !== '262'
        && (!mv.approvedDateTime || mv.extraRefId === extraId)
        && items.map(i => i.materialCode).includes(mv.materialCode)
        && mv.materialDescription !== 'DIW'
      ).map(mv => ({
        ...mv,
        materialRequestQty: items.find(item => item.materialCode === mv.materialCode)?.requestQty
      }))
      dispatch({ 
        type: PicklistAction.PicklistItemMovementsUpdated, 
        payload: { 
          itemMovements: mvs
        }})
    }
    fetchMovements(id!)
  }, [ id, items, extraId ])

  useEffect(() => {
    if (itemMovements.length > 0) {
      setExpandedGroupIds(new Set(itemMovements.map(itm => itm.materialCode)))
    }
  }, [ itemMovements ])

  const onRowsChange = async (rows: DgtPdOrderPicklistMovement[], 
    changedInfo: RowsChangeData<DgtPdOrderPicklistMovement>) => {
    const changedRowIdx = changedInfo.indexes[0]
    if (changedRowIdx < 0) return
    
    const changedRow = rows[changedRowIdx]

    const updated = changedRow.checkedDateTime! > 0 ?
      await checkItemMovement(changedRow, username!) : await uncheckItemMovement(changedRow)
    dispatch({ 
      type: PicklistAction.PicklistItemMovementsUpdated,
      payload: {
        itemMovements: rows.map(row => row.sk === updated.sk ? updated : row)
      }
    })
  }

  const disabledComplete = itemMovements.length !== itemMovements.filter(mv => mv.checkedDateTime).length

  let columns = Array.from(PicklistItemCheckMvColumn)
  if (readOnly) columns.splice(-1)

  const withDrawItems = new Set(itemMovements.map(itm => itm.materialCode))

  const mapBarcodeMovements = useMemo(() => {
    return itemMovements.map(mv => {
      const barcodeItem = items.find(itm => itm.materialCode === mv.materialCode)?.barcodePkg
      if (barcodeItem) return { ...mv, barcode: barcodeItem }
      return mv
    })
  }
  , [ itemMovements, items ])

  return <div className="page-container">
    <HeaderDetail title={`${title} Order : ${id} (เบิกเพิ่ม ขอเมื่อ ${formatDateFromUnix(header?.requestedDateTime)})`} header={header}
      isShowRelease={false} isShowRemark={true} />
    <div className='flex items-end justify-between mt-1 mb-2'>
      <small>จ่าย {withDrawItems.size} รายการ</small>
      {readOnly ? null : <button className='gap-1 btn-success' onClick={openDialog} disabled={disabledComplete}>
        <AiOutlineCheckCircle />กดเพื่อ COMPLETE
      </button>}
    </div>
    <DataGrid className='mb-3' 
      style={{ height: "100%", contain: "none" }}
      columns={columns}
      rows={mapBarcodeMovements}
      rowKeyGetter={(row) => row.id}
      groupBy={['materialCode']}
      rowGrouper={rowGrouper}
      expandedGroupIds={expandedGroupIds}
      onExpandedGroupIdsChange={setExpandedGroupIds}
      defaultColumnOptions={{ resizable: true }}
      onRowsChange={onRowsChange}
      rowHeight={(arg) => {
        if (arg.type === 'GROUP' && arg.row.childRows[0].barcode) return 55
        return 35
      }}
    />
    <small>รายการที่ไม่มีจ่าย</small>
    <div className='flex flex-row flex-wrap gap-3 mt-2 mb-3'>
      {items
        .filter(itm => !Array.from(withDrawItems).includes(itm.materialCode))
        .map(itm => 
          <Badge key={itm.id} variant='outline-muted'>
            {`${itm.materialCode} - ${itm.materialDescription} = ${itm.requestQty} ${itm.materialUnit}`}
          </Badge>
        )
      }
    </div>
    <Link to={`/picklist-check/${id}`} target="_blank"
      className='float-right '>
      <h6 className='text-blue-600 underline '>กดดูใบเบิกหลัก PD Order {id}</h6>
    </Link>
    <Modal show={showConfirmDialog} cancelText='ยกเลิก'
      onHide={closeDialog}
      okText="COMPLETE"
      okTheme='success'
      okAction={onApproved}
      title={`คุณกำลังยืนยันว่านับ Component ของใบเบิกของ ORDER ${id} ครบถ้วน`}>
      <h6>คุณยืนยันใช่หรือไม่ ?</h6>
    </Modal>
  </div>
}

export default PicklistCheckDetailExtra